module.exports = __webpack_public_path__ + "static/farmyardbathmain-f0a9e3219a6182e79c3342a46422eaba.png";